import { render, staticRenderFns } from "./DrawdownChart.vue?vue&type=template&id=18b9532c&"
import script from "./DrawdownChart.vue?vue&type=script&lang=js&"
export * from "./DrawdownChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports